import BottomLine from "./bottomLine";
import Subtitle from "./subtitle";
import Chip from "./chip";

const highlights = [
  "React.js",
  "Next.js",
  "Node.js",
  "Nest.js",
  "TypeScript",
  "PostgreSQL",
  "Docker",
  "GCP",
];

function Paragraph({ text }) {
  return (
    <p className="py-3 text-center font-mono text-slate-800 font-normal text-lg leading-7">
      {text}
    </p>
  );
}

export default function About() {
  return (
    <div className="h-full w-[90%] flex flex-col justify-center items-center md:w-[60%] lg:w-[50%]">
      <Subtitle text={"About me"} className="text-3xl md:text-5xl" />
      <BottomLine />
      <Paragraph
        text={`I'm a Software Engineer from Paraná, Brazil, currently working as a
          Full Stack Developer at Digital Republic, allocated to AZZAS 2154.
          I hold a Bachelor's degree in Engineering and an MBA in Software
          Engineering, both from UTFPR, plus a Master's degree from the
          Instituto Politécnico de Bragança, in Portugal.`}
      />
      <Paragraph
        text={`Since starting my journey into software development in 2022, I've
          worked across the full stack, building interfaces with React.js and
          Next.js styled from Figma prototypes, and designing scalable
          backend services with Node.js and Nest.js, from data modeling to
          deployment on cloud infrastructure like GCP and AWS.`}
      />
      <Paragraph
        text={`I care about code quality and reliability, writing automated tests
          with Jest, Vitest and Playwright, and setting up CI/CD pipelines
          and monitoring with GitHub Actions and Sentry. I enjoy solving
          problems, working well in a team, and I'm always learning — right
          now I'm exploring building with the Claude API and agent skills.`}
      />

      <div className="pt-4 flex flex-wrap justify-center gap-2">
        {highlights.map((skill, index) => (
          <Chip key={index} text={skill} filled />
        ))}
      </div>
    </div>
  );
}
